import { lazy } from 'react'

const Dashboard = lazy(() => import('@/pages/protected/dashboard'))
const SubmittedBids = lazy(() => import('@/pages/protected/submitted-bids'))

import { Login } from '@/pages/auth'

export { Dashboard, Login, SubmittedBids }
